import { CareResourcesProduct } from 'projects/sharedComponents/src/generated/contentful-graphql-types';

export function getContentfulProductFullName(product: Pick<CareResourcesProduct, 'company' | 'name'>): string {
  return `${!!product.company ? product.company + ' ' : ''}${product.name}`;
}
